__turbopack_context__.v({
  "className": "recifetext_e3254dea-module__k2JAHW__className",
  "variable": "recifetext_e3254dea-module__k2JAHW__variable",
});
